<template>
  <v-dialog :value="updateSystem" fullscreen transition="dialog-bottom-transition">
    <v-card class="system-update" color="primary">
      <v-row>
        <v-col cols="12">
          <p class="display-2 d-block white--text">Обновление системы! Подождите...</p>
        </v-col>
        <v-col cols="12" class="d-flex justify-center">
          <v-progress-circular indeterminate size="60" width="5" color="white" />
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import { defineComponent } from 'vue';
import useUpdateSystemStore from '@/store/updateSystem';
export default defineComponent({
  name: 'UpdateSystem',
  computed: {
    ...mapState(useUpdateSystemStore, {
      updateSystem: 'updateSystem',
    }),
  },
});
</script>
<style scoped></style>
